import { QueryClient } from "@tanstack/react-query";

const taskTypeQueryKeys = [
    [["taskType", "taskTypes"]],
    [["taskType", "agencyTaskTypes"]],
    [["taskType", "officeTaskTypeState"]],
];

const marketingPlaybookQueryKey = [["marketingPlaybook"]];

export const invalidateTaskTypes = async (queryClient: QueryClient): Promise<void> => {
    await Promise.all([
        ...taskTypeQueryKeys.map(queryKey =>
            queryClient.invalidateQueries({ queryKey, refetchType: "all" }),
        ),
        queryClient.invalidateQueries({ queryKey: marketingPlaybookQueryKey }),
    ]);
};
